import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useBreakPoint } from '@repo/toolkit/use-break-point'
import Typography from '@repo/ui/typography'
import { useEffect } from 'react'

import withTheme from '../../components/hoc/with-theme'
import AuthLayout from '../../components/layouts/auth-layout'
import { SsoLoginForm } from '../../components/pages/login/sso-login-form'
import useTranslate from '../../lib/hooks/use-translate'

export const StaffLoginPage = () => {
  const device = useBreakPoint()
  const isMobile = device === 'mobile'
  const { t } = useTranslate()

  useEffect(() => {
    document.querySelector('html')?.setAttribute('data-theme', 'staff')
  }, [])

  return (
    <AuthLayout useTranslation text={t('staff.personal.space.welcome')} variant="staff">
      <div className="mobile:h-[50vh] mobile:flex mobile:flex-col  mobile:justify-center ">
        <Typography
          variant={'h1'}
          className="mb-4"
          color={isMobile ? tailwindColors.white.DEFAULT : tailwindColors.black.DEFAULT}
        >
          {t('staff.personal.space.connect')}
        </Typography>
        <SsoLoginForm />
      </div>
    </AuthLayout>
  )
}

export default withTheme(StaffLoginPage, 'staff')
